import * as React from 'react';
import { useDispatch } from 'react-redux';
import { underControl } from '../redux/userRelated/userSlice';
import { underStudentControl } from '../redux/studentRelated/studentSlice';
import MuiAlert from '@mui/material/Alert';
import { Snackbar } from '@mui/material';

const Popup = ({ message, setShowPopup, showPopup }) => {
    const dispatch = useDispatch();

    const vertical = "top"
    const horizontal = "right"

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowPopup(false);
        dispatch(underControl())
        dispatch(underStudentControl())
    };

    const getSeverity = (msg) => {
        if (!msg) return "info";
        const lowerMsg = msg.toLowerCase();
        if (
            lowerMsg.includes("success") || 
            lowerMsg.includes("done") || 
            lowerMsg.includes("added") || 
            lowerMsg.includes("updated") || 
            lowerMsg.includes("imported") ||
            lowerMsg.includes("removed")
        ) {
            return "success";
        }
        if (
            lowerMsg.includes("error") || 
            lowerMsg.includes("failed") || 
            lowerMsg.includes("unable") ||
            lowerMsg.includes("already") ||
            lowerMsg.includes("invalid") ||
            lowerMsg.includes("not found")
        ) {
            return "error";
        }
        return "info";
    };

    const severity = getSeverity(message);

    return (
        <>
            <Snackbar open={showPopup} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal}>
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%', borderRadius: '8px', fontWeight: 500 }}>
                    {message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default Popup;

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
